// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_IR7","cls2":"common-cls2_sbN common-cls1_IR7"};